import { Heart } from "lucide-react";

export const AMOUNTS = [1, 3, 5, 10, 20];

export const parseAmount = (v) => {
  const s = String(v ?? "").trim().replace(",", ".");
  if (!/^\d{1,5}(\.\d{1,2})?$/.test(s)) return null;
  const n = Number(s);
  return n > 0 && n <= 10000 ? n : null;
};

export const euro = (n) => `${Number.isInteger(n) ? n : n.toFixed(2).replace(".", ",")} €`;

export function AmountPicker({ sel, setSel, custom, setCustom, error }) {
  const chip = (on) => `h-12 rounded-2xl text-base font-extrabold inline-flex items-center justify-center gap-1.5 ring-1 transition-[background-color,color,transform,box-shadow] active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500 ${on ? "pink-gradient text-white ring-transparent shadow-lg shadow-rose-300/50" : "bg-white text-rose-700 ring-pink-200 hover:bg-rose-50"}`;
  return (
    <div>
      <div className="grid grid-cols-3 gap-2.5" role="radiogroup" aria-label="Betrag wählen" data-testid="cs-amounts">
        {AMOUNTS.map((a) => (
          <button key={a} type="button" role="radio" aria-checked={sel === a} onClick={() => setSel(a)} data-testid={`cs-amount-${a}`} className={chip(sel === a)}>
            <Heart className={`w-4 h-4 ${sel === a ? "fill-white" : "fill-rose-200 text-rose-400"}`} /> {a} €
          </button>
        ))}
        <button type="button" role="radio" aria-checked={sel === "custom"} onClick={() => setSel("custom")} data-testid="cs-amount-custom" className={`${chip(sel === "custom")} text-sm`}>
          <Heart className={`w-4 h-4 ${sel === "custom" ? "fill-white" : "fill-rose-200 text-rose-400"}`} /> Eigener
        </button>
      </div>
      {sel === "custom" && (
        <label className="block mt-4 cs-pop" htmlFor="cs-custom-amount">
          <span className="text-sm font-bold text-slate-700">Dein Wunschbetrag in Euro</span>
          <span className={`mt-1.5 flex items-center h-14 rounded-2xl bg-white ring-2 px-4 ${error ? "ring-red-400" : "ring-pink-200 focus-within:ring-rose-500"} transition-[box-shadow]`}>
            <input id="cs-custom-amount" autoFocus inputMode="decimal" value={custom} onChange={(e) => setCustom(e.target.value.replace(/[^0-9,.]/g, "").slice(0, 8))}
              placeholder="z. B. 7,50" aria-invalid={!!error} aria-describedby="cs-amount-error" data-testid="cs-custom-input"
              className="flex-1 min-w-0 bg-transparent outline-none text-xl font-extrabold text-slate-900 placeholder:text-slate-300" />
            <span className="text-xl font-extrabold text-rose-500">€</span>
          </span>
        </label>
      )}
      <p id="cs-amount-error" role="alert" aria-live="polite" className="mt-2 min-h-[1.25rem] text-sm font-semibold text-red-600" data-testid="cs-amount-error">{error}</p>
    </div>
  );
}
